export default __webpack_public_path__ + "ba59e6b47d919ebe18a80311e9686e31.pdf";